module.exports = __webpack_public_path__ + "static/media/firstPictureMiddle.31f58e86.jpg";